import { DateInput } from "@mantine/dates"
import { MRT_Column, MRT_RowData } from "mantine-react-table"

interface Props<TData extends MRT_RowData> {
  column: MRT_Column<TData, unknown>
}

export function MRT_DateInputFilter<TData extends MRT_RowData>({
  column,
}: Props<TData>) {
  const value = column.getFilterValue()
  return (
    <DateInput
      clearable
      //TODO: probably is null here more correct (null is possible DateValue, undefined propably means this component is uncontrolled)
      value={typeof value === "string" ? value : undefined}
      onChange={(value) =>
        column.setFilterValue(value ? new Date(value) : null)
      }
      valueFormat="L"
      variant="filled"
    />
  )
}
